(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3292],{

/***/ 34847:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/faq/[id]",
      function () {
        return __webpack_require__(23425);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_AdExchangeComponent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/common/ImpressionLoggerWithCallback.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ImpressionLoggerWithCallback = function(props) {
    var _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled, _once = props.once, once = _once === void 0 ? false : _once;
    var shouldLog = (0,react.useRef)(true);
    var itemRef = (0,react.useRef)(null);
    var setLoggingEnabled = function() {
        shouldLog.current = true;
    };
    var setLoggingDisabled = function() {
        shouldLog.current = false;
    };
    (0,react.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) {
                    return;
                }
                if (!shouldLog.current) {
                    return;
                }
                if (once) {
                    setLoggingDisabled();
                }
                props.onImpressionLog();
            });
        });
        if (itemRef.current) {
            observer.observe(itemRef.current);
        }
        return function() {
            if (itemRef.current) {
                observer.unobserve(itemRef.current);
            }
        };
    }, [
        enabled
    ]);
    (0,react.useEffect)(function() {
        setLoggingEnabled();
        return function() {
            setLoggingDisabled();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        ref: itemRef,
        children: props.children
    });
};
/* harmony default export */ var common_ImpressionLoggerWithCallback = (ImpressionLoggerWithCallback);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8eb9f93-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/hooks/auth/useAuth.ts
var useAuth = __webpack_require__(31310);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
;// CONCATENATED MODULE: ./src/components/common/AdExchangeComponent.tsx





var BannerAdExchangeContext = /*#__PURE__*/ (0,react.createContext)(null);
var useBannerAdExchange = function() {
    return (0,react.useContext)(BannerAdExchangeContext);
};
var AdExchangeComponent = function(param) {
    var children = param.children, fallback = param.fallback, bannerAdExchange = param.bannerAdExchange, onImpressionLog = param.onImpressionLog;
    if (!bannerAdExchange) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: fallback
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerAdExchangeContext.Provider, {
        value: bannerAdExchange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ImpressionLoggerWithCallback, {
            onImpressionLog: onImpressionLog,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: children
            })
        })
    });
};
/* harmony default export */ var common_AdExchangeComponent = (AdExchangeComponent);
var DeliberatedCode = function() {
    var bannerAdExchange = useBannerAdExchange();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "typography-ui-10r text-center text-gray-300",
        children: bannerAdExchange.deliberatedCode
    });
};
var Content = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,style.cn)("flex w-full flex-col justify-center gap-[8px]", className),
        children: children
    });
};
var ImageAd = function(param) {
    var className = param.className;
    var token = (0,useAuth/* default */.Z)().token;
    var bannerAdExchange = useBannerAdExchange();
    var _title, ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        onClick: function() {
            return bannerAdExchange.action(token);
        },
        className: (0,style.cn)("cursor-pointer object-contain", className),
        src: bannerAdExchange.bannerImageUrl,
        alt: (ref = (_title = bannerAdExchange.title) !== null && _title !== void 0 ? _title : bannerAdExchange.deliberatedCode) !== null && ref !== void 0 ? ref : ""
    });
};
AdExchangeComponent.ImageAd = ImageAd;
AdExchangeComponent.Content = Content;
AdExchangeComponent.DeliberatedCode = DeliberatedCode;


/***/ }),

/***/ 31310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4415);


var useAuth = function() {
    var token = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilValue)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__/* .tokenState */ .J1);
    return {
        token: token
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 23425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 90 modules
var react_markdown = __webpack_require__(91650);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/components/atom/TagList.tsx
var TagList = __webpack_require__(20254);
// EXTERNAL MODULE: ./src/components/common/ContentMarkDown/index.tsx
var ContentMarkDown = __webpack_require__(2478);
// EXTERNAL MODULE: ./src/components/common/LinkTag/index.tsx
var LinkTag = __webpack_require__(23889);
// EXTERNAL MODULE: ./src/components/common/MarkdownToc/index.tsx
var MarkdownToc = __webpack_require__(53333);
// EXTERNAL MODULE: ./src/components/common/communication/ContentBottom.tsx + 5 modules
var ContentBottom = __webpack_require__(71314);
// EXTERNAL MODULE: ./src/components/common/communication/ContentRelatedQna.tsx
var ContentRelatedQna = __webpack_require__(24412);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/StickyAppHeader/index.tsx + 4 modules
var StickyAppHeader = __webpack_require__(77314);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/templates/communication/Magazine/MagazineDetailTemplate/index.tsx + 5 modules
var MagazineDetailTemplate = __webpack_require__(14037);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
;// CONCATENATED MODULE: ./src/components/templates/communication/Faq/FaqDetailTemplate/FaqStickeyButton/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    div + div {\n        margin: 0;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n  gap: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  text-decoration: line-through;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var FaqStickeyButton = function(param) {
    var faq = param.faq, bottomButtonText = param.bottomButtonText, onClickButton = param.onClickButton, shouldShowEventText = param.shouldShowEventText;
    var EventContent = function() {
        switch(faq.bottomButtonType){
            case magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            case magazine/* MagazineBottomButtonType.QUESTION */.wK.QUESTION:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextArea, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                            children: "의료진 첫 답변"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedEventText, {
                            children: "0원!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LineThroughEventText, {
                            children: "1,900원"
                        })
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTemplate/* StickyButtonWrapper */.Ny, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyArea, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default.Button */.Z.Button, {
                    text: bottomButtonText,
                    onClick: onClickButton
                }),
                shouldShowEventText && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContent, {})
            ]
        })
    });
};
/* harmony default export */ var FaqDetailTemplate_FaqStickeyButton = (FaqStickeyButton);
var StickyArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a309e1f7-0"
})(_templateObject());
var EventTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a309e1f7-1"
})(_templateObject1());
var EventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a309e1f7-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15M, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var HighlightedEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a309e1f7-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15SB, ";\n    color: ").concat(theme.color.primary700, ";\n  ");
});
var _EventTextWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a309e1f7-4"
})(_templateObject4());
var LineThroughEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a309e1f7-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12R, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});

// EXTERNAL MODULE: ./src/components/templates/communication/Magazine/MagazineDetailTemplate/MagazineDetailTags/index.tsx
var MagazineDetailTags = __webpack_require__(32391);
// EXTERNAL MODULE: ./src/components/templates/communication/Magazine/MagazineDetailTemplate/RelatedMagazineList/index.tsx
var RelatedMagazineList = __webpack_require__(62200);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/AppInstallTopBanner.tsx
var AppInstallTopBanner = __webpack_require__(79125);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Magazine/MagazineDetailSkeleton.tsx
var MagazineDetailSkeleton = __webpack_require__(75903);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/components/templates/communication/Faq/FaqDetailTemplate/index.tsx



function FaqDetailTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 8px 24px 32px 24px;\n\n  hgroup {\n    display: flex;\n    flex-direction: column;\n    word-break: keep-all;\n    width: 100%;\n    padding-right: 24px;\n    white-space: pre-wrap;\n  }\n\n  h1 {\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 8px;\n    word-break: keep-all;\n  }\n\n  h2 {\n    width: fit-content;\n    word-break: keep-all;\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 8px;\n  }\n\n  time {\n    ",
        ";\n    color: ",
        ";\n\n    svg {\n      margin: 0 8px;\n    }\n  }\n"
    ]);
    FaqDetailTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

























var FaqDetailTemplate = function(param) {
    var viewModel = param.viewModel, topBannerViewModel = param.topBannerViewModel, client = param.client;
    var ref, ref1;
    if (!viewModel.faq) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailSkeleton/* default */.Z, {});
    }
    var ref2, ref3, _createdAt, _magazinePid, _magazinePid1, _magazinePid2, _footnote, _magazinePid3, _title, _description, _prevFaqPid, _nextFaqPid;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                    title: "1분 FAQ"
                })
            }),
            client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB && topBannerViewModel.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInstallTopBanner/* default */.Z, {
                onClickClose: topBannerViewModel.hideBanner,
                content: "web_top_bnr_details",
                trackingInfo: {
                    campaign: "web_content_faq",
                    contentId: viewModel.faq.magazinePid,
                    contentTitle: viewModel.faq.title,
                    contentCategory: (ref2 = (ref = viewModel.diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) !== null && ref2 !== void 0 ? ref2 : "",
                    contentSubCategory: (ref3 = (ref1 = viewModel.departmentTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref3 !== void 0 ? ref3 : ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTemplate/* Background */.Aq, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                    children: [
                        client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTemplate/* BreadCrumbsWrapper */.XQ, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                                visible: true,
                                name: viewModel.faq.title,
                                path: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(viewModel.faq.title),
                                urlParameter: viewModel.faq.magazinePid,
                                type: "magazine"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineDetailTemplate/* Wrapper */.im, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("hgroup", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: viewModel.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: viewModel.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                dateTime: (0,format/* absoluteTime */.wE)((_createdAt = viewModel.faq.createdAt) !== null && _createdAt !== void 0 ? _createdAt : dayjs_min_default()().date()),
                                                children: dayjs_min_default()(viewModel.faq.createdAt).format("YYYY.MM.DD")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineDetailTemplate/* Content */.VY, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTemplate/* MarkDown */.sd, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentMarkDown/* default */.Z, {
                                                markdown: viewModel.faqContent,
                                                components: {
                                                    h2: function(node) {
                                                        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                            rest[_key - 1] = arguments[_key];
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            id: "".concat(node.children)
                                                        }, rest), {
                                                            children: node.children
                                                        }));
                                                    },
                                                    h3: function(node) {
                                                        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                            rest[_key - 1] = arguments[_key];
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            id: "".concat(node.children)
                                                        }, rest), {
                                                            children: node.children
                                                        }));
                                                    },
                                                    h4: function(node) {
                                                        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                            rest[_key - 1] = arguments[_key];
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            id: "".concat(node.children)
                                                        }, rest), {
                                                            children: node.children
                                                        }));
                                                    },
                                                    div: function(node) {
                                                        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                            rest[_key - 1] = arguments[_key];
                                                        }
                                                        if (node.className === "toc") {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                id: "toc"
                                                            }, rest), {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownToc/* default */.Z, {
                                                                    content: viewModel.faqContent,
                                                                    magazineTocLogger: viewModel.magazineTocLogger
                                                                })
                                                            }));
                                                        }
                                                        if (node.className === "cta5" || node.className === "cta4") {
                                                            var cta5 = node.children[1];
                                                            var _props = cta5.props, name = _props.name, value = _props.value, children = _props.children;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                className: node.className
                                                            }, rest), {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    name: name,
                                                                    onClick: function() {
                                                                        return viewModel.moveToHospital(value);
                                                                    },
                                                                    children: children
                                                                })
                                                            }));
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            className: node.className
                                                        }, rest), {
                                                            children: node.children
                                                        }));
                                                    }
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineDetailTemplate/* MagazineTagsWrapper */.dU, {
                                            children: [
                                                viewModel.diseaseTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTags/* default */.Z, {
                                                    title: "관련 질병 알아보기",
                                                    magazinePid: (_magazinePid = viewModel.faq.magazinePid) !== null && _magazinePid !== void 0 ? _magazinePid : "",
                                                    tags: viewModel.diseaseTags,
                                                    onClick: viewModel.moveToTotalSearch
                                                }),
                                                viewModel.symptomTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTags/* default */.Z, {
                                                    title: "관련 증상 알아보기",
                                                    magazinePid: (_magazinePid1 = viewModel.faq.magazinePid) !== null && _magazinePid1 !== void 0 ? _magazinePid1 : "",
                                                    tags: viewModel.symptomTags,
                                                    onClick: viewModel.moveToTotalSearch
                                                }),
                                                viewModel.departmentTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTags/* default */.Z, {
                                                    title: "관련 진료 병원 찾기",
                                                    magazinePid: (_magazinePid2 = viewModel.faq.magazinePid) !== null && _magazinePid2 !== void 0 ? _magazinePid2 : "",
                                                    tags: viewModel.departmentTags,
                                                    onClick: viewModel.moveToHospital
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTemplate/* FootNote */.Ob, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                                children: (_footnote = viewModel.faq.footnote) !== null && _footnote !== void 0 ? _footnote : ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTemplate/* TagWrapper */.nf, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagList/* default */.Z, {
                                                tags: viewModel.faqTagNames.map(function(tag) {
                                                    return tag;
                                                }),
                                                padding: [
                                                    8,
                                                    16
                                                ],
                                                onClickTagName: viewModel.onClickTag
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTemplate/* Bottom */.z, {
                                            isLiked: viewModel.faq.isLikedByMe,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBottom/* default */.Z, {
                                                onClickLike: viewModel.onClickLike,
                                                isLikedByMe: viewModel.faq.isLikedByMe,
                                                likeCount: viewModel.faq.likeCount,
                                                copyUrl: viewModel.copyUrl,
                                                onClickLog: viewModel.onClickShare,
                                                id: (_magazinePid3 = viewModel.faq.magazinePid) !== null && _magazinePid3 !== void 0 ? _magazinePid3 : "",
                                                title: (_title = viewModel.faq.title) !== null && _title !== void 0 ? _title : "",
                                                description: (_description = viewModel.faq.description) !== null && _description !== void 0 ? _description : "",
                                                titleImageUrl: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-magazine.png"),
                                                onRecordLog: viewModel.onRecordLog
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineDetailTemplate/* NavigatorWrapper */.Cu, {
                                            children: [
                                                viewModel.prevFaqPid && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                                    href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(viewModel.prevFaqPid),
                                                    onClickNavigateToScreen: function() {
                                                        return viewModel.onClickPrevNextFaq((_prevFaqPid = viewModel.prevFaqPid) !== null && _prevFaqPid !== void 0 ? _prevFaqPid : "");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineDetailTemplate/* PrevNavigator */.Tl, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                                name: "arrow_back",
                                                                size: 16,
                                                                color: theme/* default.color.gray600 */.Z.color.gray600
                                                            }),
                                                            "이전 글"
                                                        ]
                                                    })
                                                }),
                                                viewModel.nextFaqPid && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                                    href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(viewModel.nextFaqPid),
                                                    onClickNavigateToScreen: function() {
                                                        return viewModel.onClickPrevNextFaq((_nextFaqPid = viewModel.nextFaqPid) !== null && _nextFaqPid !== void 0 ? _nextFaqPid : "");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineDetailTemplate/* NextNavigator */.j4, {
                                                        children: [
                                                            "다음 글",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                                name: "arrow_forward",
                                                                size: 16,
                                                                color: theme/* default.color.gray600 */.Z.color.gray600
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                viewModel.relatedFaq && viewModel.relatedFaq.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedMagazineList/* default */.Z, {
                                    totalRelatedMagazines: viewModel.relatedFaq,
                                    totalRelatedMagazinesTitle: "이런 콘텐츠는 어떠세요?",
                                    moveOtherMagazine: viewModel.moveOtherMagazine
                                }),
                                viewModel.faqRelatedQna && viewModel.faqRelatedQna.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailTemplate/* Divider */.iz, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRelatedQna/* default */.Z, {
                                            relatedQna: viewModel.faqRelatedQna,
                                            onClickRelatedQna: viewModel.onClickRelatedQna
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqDetailTemplate_FaqStickeyButton, {
                            faq: viewModel.faq,
                            bottomButtonText: viewModel.bottomButtonText,
                            shouldShowEventText: viewModel.shouldShowEventText(),
                            onClickButton: viewModel.handleStickyButton
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Faq_FaqDetailTemplate = (FaqDetailTemplate);
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-4f9d59d8-0"
})(FaqDetailTemplate_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI36SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray800;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI18M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});

// EXTERNAL MODULE: ./src/hooks/Cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(72105);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
;// CONCATENATED MODULE: ./src/constants/logs/faq/index.ts
var FAQ_LOG_EVENT = {
    CLICK_FAQ_TOC: "click_faq_toc",
    CLICK_FAQ_TAG: "click_faq_tag",
    UPPER_FAQ_SHARE_CLICK: "upper_faq_share_click",
    DETAIL_STICKY_BUTTON_CLICK: "faq_detail_sticky_button_click",
    FAQ_RELATED_QNA_CLICK: "faq_related_qna_click",
    FAQ_RELATED_BOARD_POST_CLICK: "faq_related_board_post_click"
};

// EXTERNAL MODULE: ./src/hooks/Cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(6191);
// EXTERNAL MODULE: ./src/constants/common/index.ts
var constants_common = __webpack_require__(95611);
// EXTERNAL MODULE: ./src/hooks/magazine/magazine.gql.impl.tsx
var magazine_gql_impl = __webpack_require__(44355);
// EXTERNAL MODULE: ./src/parsers/Communication/magazine/index.ts
var Communication_magazine = __webpack_require__(72733);
;// CONCATENATED MODULE: ./src/hooks/faq/useGetRelatedFaq.ts





var useGetRelatedFaq = function(faqPid) {
    var ref = (0,magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery */.yH)({
        request: {
            size: 4,
            magazinePid: faqPid
        }
    }, {
        select: Communication_magazine/* parseRelatedMagazines */.Ez,
        staleTime: constants_common/* SIX_HOURS_IN_MILLISECONDS */.At,
        cacheTime: constants_common/* SIX_HOURS_IN_MILLISECONDS */.At
    }), relatedFaq = ref.data;
    return {
        relatedFaq: relatedFaq
    };
};
/* harmony default export */ var faq_useGetRelatedFaq = (useGetRelatedFaq);
useGetRelatedFaq.getKey = function(faqPid) {
    return magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.getKey */.yH.getKey({
        request: {
            size: 4,
            magazinePid: faqPid
        }
    });
};
useGetRelatedFaq.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, faqPid) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.getKey */.yH.getKey({
                            request: {
                                size: 4,
                                magazinePid: faqPid
                            }
                        }), magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.fetcher */.yH.fetcher({
                            request: {
                                size: 4,
                                magazinePid: faqPid
                            }
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, faqPid) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/magazine/useGetMagazineDetail.ts
var useGetMagazineDetail = __webpack_require__(6150);
// EXTERNAL MODULE: ./src/hooks/magazine/useGetPrevNextMagazinePid.ts
var useGetPrevNextMagazinePid = __webpack_require__(54110);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/Write/useCanProgressQnaWrite.tsx
var useCanProgressQnaWrite = __webpack_require__(15126);
// EXTERNAL MODULE: ./src/hooks/qna/useGetMagazineRelatedQna.ts
var useGetMagazineRelatedQna = __webpack_require__(35640);
// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/hooks/useClickContentLike.ts
var useClickContentLike = __webpack_require__(5872);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useMoveToHospitalSearch.ts
var useMoveToHospitalSearch = __webpack_require__(17440);
// EXTERNAL MODULE: ./src/hooks/useMoveToTotalSearch.ts
var useMoveToTotalSearch = __webpack_require__(23483);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/hooks/faq/useFaqDetailViewModel.ts























var useFaqDetailViewModel = function(param) {
    var faqPid = param.faqPid, client = param.client;
    var faq = (0,useGetMagazineDetail/* default */.Z)(faqPid);
    var moveToHospital = (0,useMoveToHospitalSearch/* default */.Z)().moveToHospital;
    var moveToTotalSearch = (0,useMoveToTotalSearch/* default */.Z)().moveToTotalSearch;
    var ref = (0,useCustomRouter/* default */.Z)(), moveToPage = ref.moveToPage, router = ref.router;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var showToast = (0,useToast/* default */.Z)().showToast;
    var clickProgressWrite = (0,useCanProgressQnaWrite/* default */.Z)().clickProgressWrite;
    var setShowAuthModal = (0,useAuthModal/* default */.Z)(true).setShowAuthModal;
    var ref1 = (0,useClickContentLike/* default */.Z)(faqPid), likeContent = ref1.likeContent, cancelLikeContent = ref1.cancelLikeContent;
    var relatedFaq = faq_useGetRelatedFaq(faqPid).relatedFaq;
    var ref2 = (0,useGetPrevNextMagazinePid/* default */.Z)(faqPid, magazine/* MagazineType.FAQ */.rL.FAQ), prevFaqPid = ref2.prevMagazinePid, nextFaqPid = ref2.nextMagazinePid;
    var ref3 = (0,useGetMagazineRelatedQna/* default */.Z)(faqPid), faqRelatedQna = ref3.magazineRelatedQna;
    var pageName = !(0,RNPlugins/* isWebView */.vp)() ? common/* ROUTES.FAQ.DETAIL.pageName */.Z6.FAQ.DETAIL.pageName : (0,logger/* getMobileWebPageName */.b9)(router);
    var copyUrl = (0,react.useMemo)(function() {
        return "".concat("https://doctornow.co.kr").concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faq === null || faq === void 0 ? void 0 : faq.magazinePid);
    }, [
        faq === null || faq === void 0 ? void 0 : faq.magazinePid
    ]);
    var title = (0,react.useMemo)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return faq === null || faq === void 0 ? void 0 : faq.mobileTitle;
        }
        return faq === null || faq === void 0 ? void 0 : faq.title;
    }, [
        faq === null || faq === void 0 ? void 0 : faq.mobileTitle,
        faq === null || faq === void 0 ? void 0 : faq.title
    ]);
    var description = (0,react.useMemo)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return faq === null || faq === void 0 ? void 0 : faq.mobileDescription;
        }
        return faq === null || faq === void 0 ? void 0 : faq.description;
    }, [
        faq === null || faq === void 0 ? void 0 : faq.mobileDescription,
        faq === null || faq === void 0 ? void 0 : faq.description
    ]);
    var faqContent = (0,react.useMemo)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return faq === null || faq === void 0 ? void 0 : faq.mobileContent;
        }
        return faq === null || faq === void 0 ? void 0 : faq.content;
    }, [
        faq === null || faq === void 0 ? void 0 : faq.content,
        faq === null || faq === void 0 ? void 0 : faq.mobileContent
    ]);
    var departmentTags = (0,react.useMemo)(function() {
        return faq === null || faq === void 0 ? void 0 : faq.tags.filter(function(tag) {
            return tag.tagType === magazine/* MagazineTagType.DEPARTMENT */.Zg.DEPARTMENT;
        });
    }, [
        faq === null || faq === void 0 ? void 0 : faq.tags
    ]);
    var diseaseTags = (0,react.useMemo)(function() {
        return faq === null || faq === void 0 ? void 0 : faq.tags.filter(function(tag) {
            return tag.tagType === magazine/* MagazineTagType.DISEASE */.Zg.DISEASE;
        });
    }, [
        faq === null || faq === void 0 ? void 0 : faq.tags
    ]);
    var symptomTags = (0,react.useMemo)(function() {
        return faq === null || faq === void 0 ? void 0 : faq.tags.filter(function(tag) {
            return tag.tagType === magazine/* MagazineTagType.SYMPTOM */.Zg.SYMPTOM;
        });
    }, [
        faq === null || faq === void 0 ? void 0 : faq.tags
    ]);
    var faqTagNames = (0,react.useMemo)(function() {
        return faq && faq.tagNames ? faq.tagNames.map(function(name) {
            return name;
        }) : [];
    }, [
        faq
    ]);
    var bottomButtonText = (0,react.useMemo)(function() {
        switch(faq === null || faq === void 0 ? void 0 : faq.bottomButtonType){
            case magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS:
                return "비대면 진료 받으러 가기";
            case magazine/* MagazineBottomButtonType.QUESTION */.wK.QUESTION:
            default:
                return "무료로 의료진에게 답변받기";
        }
    }, [
        faq === null || faq === void 0 ? void 0 : faq.bottomButtonType,
        client.isWebView
    ]);
    var shouldShowEventText = function() {
        return !(0,RNPlugins/* isWebView */.vp)();
    };
    var bottomButtonDynamicLink = function() {
        var ref, ref1;
        airbridge/* default.setDynamicLink */.Z.setDynamicLink({
            campaign: "web_content_faq",
            content: "web_bottom_flt_details",
            term: bottomButtonText,
            sub_id: faq === null || faq === void 0 ? void 0 : faq.magazinePid,
            sub_id_1: faq === null || faq === void 0 ? void 0 : faq.title,
            sub_id_2: (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) || "",
            sub_id_3: (departmentTags === null || departmentTags === void 0 ? void 0 : (ref1 = departmentTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
        });
    };
    var magazineTocLogger = function() {
        (0,logger/* magazineLogger */.Uj)({
            eventName: FAQ_LOG_EVENT.CLICK_FAQ_TOC,
            pageName: (0,logger/* getPageName */.j0)(router),
            payload: {
                id: faqPid
            }
        });
    };
    var onClickTag = function(tagName) {
        (0,logger/* faqLogger */.lp)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: FAQ_LOG_EVENT.CLICK_FAQ_TAG,
            payload: {
                faqPid: faqPid,
                tagType: magazine/* MagazineTagType.FREE */.Zg.FREE,
                tagName: tagName
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.TAG.path */.Z6.FAQ.TAG.path, "?tag=").concat(tagName),
            mobileScreenName: common/* ROUTES.FAQ.TAG.appScreenName */.Z6.FAQ.TAG.appScreenName,
            params: {
                tag: tagName
            }
        });
    };
    var handleLikeClick = (0,react.useCallback)(function() {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "faq_content_detail_".concat((faq === null || faq === void 0 ? void 0 : faq.isLikedByMe) ? "disLike" : "like", "_button_click"),
                pageName: pageName
            }
        });
        if (faq === null || faq === void 0 ? void 0 : faq.isLikedByMe) {
            cancelLikeContent();
            return;
        }
        likeContent();
    }, [
        cancelLikeContent,
        likeContent,
        faq === null || faq === void 0 ? void 0 : faq.isLikedByMe,
        pageName
    ]);
    var onClickLike = function() {
        if (!token) {
            showToast({
                message: "로그인 후 이용할 수 있어요."
            });
            setShowAuthModal(true);
            return;
        }
        handleLikeClick();
    };
    var onClickShare = function() {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: FAQ_LOG_EVENT.UPPER_FAQ_SHARE_CLICK
        });
    };
    var onRecordLog = function(logName) {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: logName
        });
    };
    var handleStickyButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,logger/* faqLogger */.lp)({
                            eventName: FAQ_LOG_EVENT.DETAIL_STICKY_BUTTON_CLICK,
                            pageName: (0,logger/* getPageName */.j0)(router),
                            payload: {
                                id: faqPid,
                                type: (faq === null || faq === void 0 ? void 0 : faq.bottomButtonType) || "",
                                platform: client.clientType
                            }
                        });
                        _ = faq === null || faq === void 0 ? void 0 : faq.bottomButtonType;
                        switch(_){
                            case magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS:
                                return [
                                    3,
                                    1
                                ];
                            case magazine/* MagazineBottomButtonType.QUESTION */.wK.QUESTION:
                                return [
                                    3,
                                    2
                                ];
                        }
                        return [
                            3,
                            2
                        ];
                    case 1:
                        if (client.isWebView) {
                            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_TAB_HOME */.nn.MOVE_TO_TAB_HOME, {
                                tabName: "HomeTab",
                                screenName: common/* ROUTES.HOME.appScreenName */.Z6.HOME.appScreenName,
                                params: {
                                    isNonFaceToFaceTreatmentRequestClick: true
                                }
                            });
                        } else {
                            bottomButtonDynamicLink();
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (!client.isWebView) {
                            bottomButtonDynamicLink();
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            clickProgressWrite()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleStickyButton() {
            return _ref.apply(this, arguments);
        };
    }();
    var moveOtherMagazine = function(magazine) {
        moveToPage({
            webLink: magazine.isArticle ? "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid) : "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(magazine.magazinePid),
            mobileScreenName: magazine.isArticle ? common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName : common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: magazine.magazinePid
            }
        });
    };
    var onClickRelatedQna = function(questionPid) {
        (0,logger/* faqLogger */.lp)({
            eventName: FAQ_LOG_EVENT.FAQ_RELATED_QNA_CLICK,
            pageName: (0,logger/* getPageName */.j0)(router),
            payload: {
                faqPid: faqPid,
                questionPid: questionPid
            }
        });
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_TAB_HOME */.nn.MOVE_TO_TAB_HOME, {
                tabName: "QuickAnswerTab",
                screenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
                params: {
                    questionId: questionPid
                }
            });
        } else {
            router.push({
                pathname: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid)
            });
        }
    };
    var onClickPrevNextFaq = function(faqPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faqPid),
            mobileScreenName: common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: faqPid
            }
        });
    };
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!faq) {
            return;
        }
        setIsCujModalTrackingInfo({
            campaignName: "web_content_faq",
            trackContent: "web_mid_mdl_details",
            contentId: faq.magazinePid,
            contentTitle: faq.title,
            contentCategory: (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) || "",
            contentSubCategory: (departmentTags === null || departmentTags === void 0 ? void 0 : (ref1 = departmentTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
        });
    }, [
        faq
    ]);
    return {
        faq: faq,
        title: title !== null && title !== void 0 ? title : "",
        description: description !== null && description !== void 0 ? description : "",
        faqContent: faqContent !== null && faqContent !== void 0 ? faqContent : "",
        magazineTocLogger: magazineTocLogger,
        moveToHospital: moveToHospital,
        departmentTags: departmentTags !== null && departmentTags !== void 0 ? departmentTags : [],
        symptomTags: symptomTags !== null && symptomTags !== void 0 ? symptomTags : [],
        diseaseTags: diseaseTags !== null && diseaseTags !== void 0 ? diseaseTags : [],
        moveToTotalSearch: moveToTotalSearch,
        faqTagNames: faqTagNames,
        onClickTag: onClickTag,
        copyUrl: copyUrl,
        onClickLike: onClickLike,
        handleLikeClick: handleLikeClick,
        onClickShare: onClickShare,
        onRecordLog: onRecordLog,
        handleStickyButton: handleStickyButton,
        relatedFaq: relatedFaq,
        moveOtherMagazine: moveOtherMagazine,
        faqRelatedQna: faqRelatedQna,
        onClickRelatedQna: onClickRelatedQna,
        prevFaqPid: prevFaqPid,
        nextFaqPid: nextFaqPid,
        onClickPrevNextFaq: onClickPrevNextFaq,
        bottomButtonText: bottomButtonText,
        shouldShowEventText: shouldShowEventText
    };
};
/* harmony default export */ var faq_useFaqDetailViewModel = (useFaqDetailViewModel);

;// CONCATENATED MODULE: ./src/pages/content/faq/[id]/index.tsx
// PageDescription: FAQ 상세 페이지










var FaqDetail = function(param) {
    var id = param.id, client = param.client;
    var ref, ref1, ref2, ref3;
    var viewModel = faq_useFaqDetailViewModel({
        faqPid: id,
        client: client
    });
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)();
    var ldJson = (0,Communication_magazine/* createFaqLdJson */.KD)(viewModel.faq);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson !== null && ldJson !== void 0 ? ldJson : {})
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat((ref = viewModel.faq) === null || ref === void 0 ? void 0 : ref.title, " - 닥터나우"),
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(id),
                description: (ref1 = viewModel.faq) === null || ref1 === void 0 ? void 0 : ref1.description,
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(id),
                    title: ((ref2 = viewModel.faq) === null || ref2 === void 0 ? void 0 : ref2.title) || "",
                    description: ((ref3 = viewModel.faq) === null || ref3 === void 0 ? void 0 : ref3.description) || "",
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-magazine.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq_FaqDetailTemplate, {
                viewModel: viewModel,
                topBannerViewModel: topBannerViewModel,
                client: client
            })
        ]
    });
};
FaqDetail.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var _id_ = (FaqDetail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,7096,2587,4329,6562,1743,6551,5247,5442,5141,4847,1293,9774,2888,179], function() { return __webpack_exec__(34847); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);